import { useNavigate } from 'react-router-dom';
import './supTickets.css';
import { useEffect, useMemo, useState } from 'react';
import ReactLoading from 'react-loading';
import { fetchAdminTickets, fetchTickets, getUsers, ticketsCount } from './ticketsFunctions/fetchTicketsInfo';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';

const SupTickets = () => {
    const tableHeader = [
        'Ticket ID',
        'Name',
        'Description',
        'Package Name',
        'Travel Date',
        'Amount',
        'Seats',
        'Status',
        'Ticket Date'
    ];
    const navigate = useNavigate();
    const [ticketsData, setTicketsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedType, setSelectedType] = useState('trip');
    const [selectedStatus, setSelectedStatus] = useState('in_progress');
    const [offset, setOffset] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(5);
    const [selectedUser, setSelectedUser] = useState('');
    const [userList, setUserList] = useState([]);
    const [createdByMe, setCreatedByMe] = useState(false);
    const limit = 10;
    const totalData = totalCount;
    const userRole = localStorage.getItem('supAccess');

    useEffect(() => {
        getUsers(setUserList, setLoading);
        if (localStorage.getItem('ticketUser')) setSelectedUser(localStorage.getItem('ticketUser'));
    }, []);

    useMemo(() => {
        if (!selectedStatus) return;
        if (userRole && (userRole === 'superAdmin' || userRole === 'admin')) {
            fetchAdminTickets(setLoading, setTicketsData, selectedType, selectedStatus, selectedUser, createdByMe);
        } else {
            fetchTickets(setLoading, setTicketsData, selectedType, selectedStatus);
        }
        //eslint-disable-next-line
    }, [selectedStatus, selectedUser, selectedType, createdByMe]);

    useMemo(() => {
        if (!selectedType) return;
        ticketsCount(setTotalCount, selectedType, setLoading);
        //eslint-disable-next-line
    }, [selectedType]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffset(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter'>
                <h1 className='supportHeader'>Tickets</h1>
                <div>
                    {(userRole === 'superAdmin' || userRole === 'admin') && (
                        <>
                            <input
                                type='checkbox'
                                id='switch'
                                value={createdByMe}
                                onChange={(e) => setCreatedByMe(e.target.checked)}
                            />
                            <label for='switch'>Toggle</label>
                        </>
                    )}
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedStatus}
                        style={{ marginRight: '8px' }}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                        <option value='in_progress'>In Progress</option>
                        <option value='resolved'>Resolved</option>
                        {/* <option value='in_active'>In Active</option> */}
                    </select>
                    {(userRole === 'superAdmin' || userRole === 'admin') && (
                        <select
                            name='type'
                            id='type'
                            className='select'
                            value={selectedUser}
                            style={{ marginRight: '8px' }}
                            onChange={(e) => {
                                setSelectedUser(e.target.value);
                                localStorage.setItem('ticketUser', e.target.value);
                            }}
                        >
                            <option value=''>All</option>
                            {userList.map((item) => (
                                <option value={item._id} key={item._id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    )}
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                    >
                        <option value='trip'>Trip</option>
                        <option value='camp'>Camp</option>
                        <option value='guide'>Guide</option>
                    </select>
                </div>
            </div>
            {ticketsData.length === 0 && !loading ? (
                <EmptyPage />
            ) : (
                <div className='table-top-container'>
                    <div className='tableContainer ticketsContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {ticketsData?.map((row, rowIndex) => {
                                    return (
                                        <tr
                                            key={rowIndex}
                                            className='tableBodyRow allowCLick'
                                            onClick={() => navigate(`/support/tickets/${row._id}`)}
                                        >
                                            <td>{row._id}</td>
                                            <td className='ellipsisCell'>{row?.userId?.name ?? 'N/A'}</td>
                                            <td className='ellipsisCell'>{row?.description ?? 'N/A'}</td>
                                            <td className='ellipsisCell'>{row?.packId?.title ?? 'N/A'}</td>
                                            <td>{row?.bookingId?.startDate?.split('T')[0] ?? 'N/A'}</td>
                                            <td>{row?.bookingId?.amountPaid?.paid ?? 'N/A'}</td>
                                            <td>{row?.bookingId?.totalSeats ?? 'N/A'}</td>
                                            <td>{row?.status ?? 'N/A'}</td>
                                            <td>{row?.updatedAt?.split('T')[0] ?? 'N/A'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {ticketsData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {row?._id}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[1]}:</strong> {row?.userId?.name ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {row?.descritpion ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> {row?.packId?.title ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong>{' '}
                                            {row?.bookingId?.startDate?.split('T')[0] ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[5]}:</strong>{' '}
                                            {row?.bookingId?.amountPaid?.paid ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[6]}:</strong> {row?.bookingId?.totalSeats ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[7]}:</strong> {row?.status ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[8]}:</strong> {row?.updatedAt?.split('T')[0] ?? 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Pagination
                        paginationClick={paginationClick}
                        numberOfRows={totalData}
                        offSet={offset}
                        pageNumber={pageNumber}
                        limit={limit}
                    />
                </div>
            )}
        </>
    );
};

export default SupTickets;
